__webpack_require__.p = "/Krish_Portfolio/";